<template>
  <div v-loading="loading">
    <el-form
      class="page-form"
      ref="pageForm1"
      :model="Business"
      :rules="pageRules1"
    >
      <p class="sub_t">Business</p>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item prop="BusinessName" label="Business Name">
            <el-input
              v-model="Business.BusinessName"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            prop="BusinessRegistrationNumber"
            label="Business Registration Number"
          >
            <el-input
              v-model="Business.BusinessRegistrationNumber"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            prop="JurisdictionOfIncorporation"
            label="Jurisdiction Of Incorporation"
          >
            <el-input
              v-model="Business.JurisdictionOfIncorporation"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      class="page-form"
      ref="pageForm2"
      :model="Location"
      :rules="pageRules2"
    >
      <p class="sub_t">Location</p>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item prop="City" label="City">
            <el-input
              v-model="Location.City"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="PostalCode" label="Postal Code">
            <el-input
              v-model="Location.PostalCode"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="Address1" label="Address 1 ">
            <el-input
              v-model="Location.Address1"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      class="page-form"
      ref="pageForm3"
      :model="Communication"
      :rules="pageRules3"
    >
      <p class="sub_t">Communication</p>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form-item prop="Telephone" label="Telephone Number">
            <el-input
              v-model="Communication.Telephone"
              type="text"
              auto-complete="off"
              placeholder="Please fill in"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import pageCard from "@/components/PageCard";
import pageBottom from "@/components/PageBottom";
import { businessKYCEntrance } from "@/api/producer.js";
import { setBusinessKYC } from "@/utils/auth.js";
export default {
  props: {
    area: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      pageData: {},
      Business:{

      },
      Location:{

      },
      Communication:{

      },
      pageRules1:{
        BusinessName: [
          {
            required: true,
            message: "Please fill in",
            trigger: "blur"
          }
        ],
        BusinessRegistrationNumber: [
          {
            required: true,
            min: 1,
            max: 50,
            message: "Within 50 characters",
            trigger: "blur"
          },
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(
                  new Error("Business Registration Number cannot be empty")
                );
              } else if (!this.dict.reg.number.value.test(value)) {
                return callback(new Error(this.dict.reg.number.desc));
              } else {
                callback();
              }
            }
          }
        ],
        JurisdictionOfIncorporation: [
          {
            required: true,
            message: "Please fill in",
            trigger: "blur"
          }
        ],
      },
      pageRules2:{
        City: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("City Code cannot be empty"));
              }
              // else if (!this.dict.reg.common.value.test(value)) {
              //   return callback(new Error(this.dict.reg.common.desc));
              // }
              else {
                callback();
              }
            }
          }
        ],
        PostalCode: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("Postal Code cannot be empty"));
              }
              // else if (!this.dict.reg.postalCode.value.test(value)) {
              //   return callback(new Error(this.dict.reg.postalCode.desc));
              // }
              else {
                callback();
              }
            }
          }
        ],
        Address1: [
          {
            required: true,
            message: "Please fill in",
            trigger: "blur"
          }
        ],
      },
      pageRules3:{

      },
      gobackConfirm: false
    };
  },
  components: { pageCard, pageBottom },
  created() {
  },
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        let rule1,rule2,rule3;
        this.$refs.pageForm1.validate(valid => {
          rule1 = valid;
        });
        this.$refs.pageForm2.validate(valid => {
          rule2 = valid;
        });
        this.$refs.pageForm3.validate(valid => {
          rule3 = valid;
        });
        if (rule1 && rule2 && rule3) {
          if(this.Location.Address1) {
            this.Location.AdditionalFields = {
              Address1:this.Location.Address1
            }
          }

          let Location = {
            ...this.Location
          }
          delete Location.Address1;
          businessKYCEntrance({
            data: {
              CountryCode:this.area,
              DataFields:{
                Business: this.Business,
                Communication: this.Communication,
                Location: Location
              }
            }
          })
            .then(res => {
              this.loading = false;
              if (res.result == "nomatch") {
                this.$message.error("Matching failed!");
                reject(res);
              }else{
                resolve({
                  CountryCode:this.area,
                  DataFields:{
                    Business: this.Business,
                    Communication: this.Communication,
                    Location: Location
                  }
                });
              }

            })
            .catch(err => {
              console.log(err);
              reject(err);
              this.loading = false;
            });
        } else {
          reject("form valid error");
          this.loading = false;
        }
      })

    }
  }
};
</script>
<style scoped lang="scss">
.sub_t {
  font-size: 0.18rem;
  font-weight: bold;
}
.page-btns {
  text-align: center;
}
</style>
